import { BLACK, PRIMARY_COLOR } from '../../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../../theme/fontConstants';

const getStyles = ({ theme, activeWeek }) => {
  const titleTypographySx = {
    fontSize: '24px',
    fontWeight: 600,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(2),
  };

  const weekTabsContainerSx = {
    borderRadius: theme.spacing(1, 1, 0, 0),
  };

  const weekTabSx = (weekNumber) => ({
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    padding: theme.spacing(1, 2),
    backgroundColor: activeWeek === weekNumber ? PRIMARY_COLOR[70] : 'transparent',
    color: activeWeek === weekNumber ? BLACK[0] : theme.palette.text.secondary,
    fontWeight: activeWeek === weekNumber ? 600 : 400,
    transition: 'all 0.2s ease',
    position: 'relative',
    '&:hover': {
      backgroundColor: activeWeek === weekNumber ? PRIMARY_COLOR[80] : 'rgba(0, 0, 0, 0.04)',
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: '2px',
      backgroundColor: activeWeek === weekNumber ? 'transparent' : PRIMARY_COLOR[70],
    },
  });

  const week1TabSx = {
    ...weekTabSx(1),
    borderRadius: theme.spacing(1, 0, 0, 0),
  };

  const week2TabSx = {
    ...weekTabSx(2),
    borderRadius: theme.spacing(0, 1, 0, 0),
    flex: 1,
  };

  const week1TabTypographySx = {
    fontSize: '16px',
    color: activeWeek === 1 ? BLACK[0] : BLACK[60],
    fontFamily: PRIMARY_FONT[700],
  };

  const week2TabTypographySx = {
    fontSize: '16px',
    color: activeWeek === 2 ? BLACK[0] : BLACK[60],
    fontFamily: PRIMARY_FONT[700],
  };

  const instructionsTypographySx = {
    fontSize: '16px',
    color: BLACK[100],
    fontFamily: PRIMARY_FONT[300],
    margin: theme.spacing(3, 0),
  };

  const daySelectionWrapperSx = {
    marginBottom: theme.spacing(3),
  };

  const dividerSx = {
    borderTop: `1px solid ${theme.palette.divider}`,
    marginBottom: theme.spacing(3),
  };

  const tableHeaderCellSx = {
    fontWeight: 600,
  };

  const tableHeaderWidthCellSx = {
    width: '50px',
  };

  const dayNameCellSx = {
    fontSize: '16px',
  };

  const shiftTimeWrapperSx = {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  };

  const timeSelectorSx = {
    width: '140px',
    height: '40px',
    paddingTop: '0px',
    paddingBottom: '0px',
    margin: '0px',
    '& .MuiOutlinedInput-root': {
      paddingTop: '0px',
      paddingBottom: '0px',
    },
    '& .MuiInputLabel-root:not(.MuiInputLabel-shrink)': {
      left: '20%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      width: 'auto',
    },
    '& .MuiInputLabel-root.MuiInputLabel-shrink': {
      left: '16%',
      transform: 'translateX(-30%) translateY(-11px) scale(0.75)',
      width: 'auto',
    },
  };

  const iconWrapperSx = {
    '& .MuiOutlinedInput-root .MuiBox-root': {
      height: '24px',
      width: '24px',
    },
  };

  const separatorTypographySx = {
    mx: 1,
  };

  const openingsTextFieldSx = {
    width: '80px',
  };

  const deleteButtonSx = {
    color: theme.palette.error.main,
  };

  const weekTotalBoxSx = {
    marginTop: theme.spacing(3),
    padding: theme.spacing(2),
    backgroundColor: PRIMARY_COLOR[10] || '#F8F4FF',
    borderRadius: theme.spacing(1),
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  };

  const weekTotalLabelTypographySx = {
    fontWeight: 600,
  };

  const weekTotalValueTypographySx = {
    fontWeight: 600,
    color: PRIMARY_COLOR[70],
  };

  const noDaysSelectedTypographySx = {
    color: theme.palette.text.secondary,
    textAlign: 'center',
    padding: theme.spacing(4),
  };

  return {
    titleTypographySx,
    weekTabsContainerSx,
    week1TabSx,
    week2TabSx,
    week1TabTypographySx,
    week2TabTypographySx,
    instructionsTypographySx,
    daySelectionWrapperSx,
    dividerSx,
    tableHeaderCellSx,
    tableHeaderWidthCellSx,
    dayNameCellSx,
    shiftTimeWrapperSx,
    timeSelectorSx,
    iconWrapperSx,
    separatorTypographySx,
    openingsTextFieldSx,
    deleteButtonSx,
    weekTotalBoxSx,
    weekTotalLabelTypographySx,
    weekTotalValueTypographySx,
    noDaysSelectedTypographySx,
  };
};

export default getStyles;
